import React from "react";

/**
 * This component retruns a jsx for the appropriate payment beneficiary status
 * @param {number} status
 * @returns - retuns jsx
 */
const paymentBeneficiariesStatus = (status) => {
    let result = "";
    switch (parseInt(status)) {
        case 0:
            result = (
                <span className="text-danger font-weight-bolder">
                    {/* Failed Processing */}
                    Failed
                </span>
            );
            break;
        case 1:
            result = (
                <span className="text-success font-weight-bolder">
                    {/* processing completed */}
                    Successful
                </span>
            );
            break;
        case 2:
            result = (
                <span className="text-success font-weight-bolder">
                    {/* debitDone */}
                    Debit Done
                </span>
            );
            break;
        case 3:
            result = (
                <span className="text-warning font-weight-bolder">
                    {/* pendingAuthorization */}
                    Pending authorization
                </span>
            );
            break;
        case 4:
            result = (
                <span className="text-warning font-weight-bolder">
                    {/* pendingDebit */}
                    Pending debit
                </span>
            );
            break;
        case 5:
            result = (
                <span className="text-info font-weight-bolder">
                    {/* initiateProcessing */}
                    Initiate processing
                </span>
            );
            break;
        case 6:
            result = (
                <span className="text-info font-weight-bolder">
                    {/* processingHeldOfflineHours */}
                    Processing held: offline hours
                </span>
            );
            break;
        case 7:
            result = (
                <span className="text-info font-weight-bolder">
                    {/* ProcessingHeldIssuerOffline */}
                    Processing held: issuer offline
                </span>
            );
            break;
        case 8:
            result = (
                <span className="text-info font-weight-bolder">
                    {/* ProcessingHeldIssuerOfflineSettlement */}
                    Processing held: issuer offline settlement
                </span>
            );
            break;
        case 9:
            result = (
                <span className="text-info font-weight-bolder">
                    {/* ProcessingIssuerOffline(9); */}
                    Processing issuer offline;
                </span>
            );
            break;
        default:
            result = <span className="text-info font-weight-bolder">Unknown status {status}</span>;
    }
    return result;
};

export default paymentBeneficiariesStatus;
